<template>

    <auth-panel v-if="!isAuth"/>

    <v-container v-else-if="client_loading||shop_loading" fluid class="fill-height">
        <v-row align="center" justify="center">
            <v-col class="text-center">
                <v-progress-circular
                        indeterminate
                        size="90"
                        width="3"
                        color="dark">
                </v-progress-circular>
            </v-col>
        </v-row>
    </v-container>

    <sidebar-menu v-else>
        <router-view/>
        <top-button v-if="!(['product_page'].includes($route.name))"/>
        <blocked-dialog/>

        <socket @onmessage="onSocketMessage" v-if="['purchase_album_detail', 'purchase_market', 'purchase_clients'].includes($route.name)" name="ClientsPurchase" :path="`purchases/clients/${$route.params.purchase_id}/`"/>

    </sidebar-menu>

</template>

<script>
    import {mapState} from 'vuex'
    import Menu from "./Menu";
    import TopButton from "./utils/TopButton";
    import Auth from "./Auth";
    import BlockedDialog from "./other/BlockedDialog";
    import Socket from "./utils/Socket";

    export default {
        name: "Shop",
        components: {
            Socket,
            BlockedDialog,
            TopButton,
            'sidebarMenu': Menu,
            "authPanel": Auth,
        },
        computed: {
            ...mapState({
                isAuth: state => state.auth.isAuth
            }),
            ...mapState({
                shop: state => state.shop.shop,
                shop_loading: state => state.shop.shop_loading,
                client_loading: state => state.clients.client_loading,
            })
        },
        methods: {
            onSocketMessage({type,data}) {
                if (type === 'clients_update') {
                    this.$store.commit('clients/addClient', data)
                }
            }
        },
        mounted() {
            if (this.isAuth) {
                // const vm = this;

                // axios.get(`${location.protocol}//worldtimeapi.org/api/timezone/Etc/UTC`)
                //     .then(response => {
                //         localStorage.setItem('dateNowUTC', response.data.datetime)
                //     })
                //     .catch(() => {
                //         localStorage.setItem('dateNowUTC', new Date(Date.now()).toISOString())
                //     })
                //     .finally(() => {
                //         vm.time_loading = false;
                //     })

                this.$store.dispatch('shop/getShop');

                this.$store.dispatch('clients/getCurrentClient')
                    .then((response) => {
                        if ('permission_denied' in response) {
                            this.$store.commit('auth/setAuthInfo', response)
                            this.$router.push({'name': 'access_denied'})
                        }
                    });
            }
        }
    }
</script>

<style scoped>

</style>